import * as CryptoJs from 'crypto-js'
import Config from '../lib/config'
import axios from 'axios';

export const isEmpty = value =>
value === undefined ||
value == "undefined" ||
value === null ||
(typeof value === 'object' && Object.keys(value).length === 0) ||
(typeof value === 'string' && value.trim().length === 0) ||
(typeof value === 'string' && value === '0')||
(typeof value === 'number' && value === 0);

export const EncryptData = (data) => {
    if(typeof(data)=='string'){
      return  CryptoJs.AES.encrypt(data,Config.KEY).toString()
    }
    else{
      return  CryptoJs.AES.encrypt(JSON.stringify(data),Config.KEY).toString()
    }
  }

export const DecryptData = (data) => {
    try{
    var bytes = CryptoJs.AES.decrypt(data, Config.KEY);
    
    var decryptedData;
    try {
      decryptedData = JSON.parse(bytes.toString(CryptoJs.enc.Utf8));
    }
    catch (err) {
      
      try {
        decryptedData = bytes.toString(CryptoJs.enc.Utf8);
        
  
      }
      catch (dcpterr) {
        
        return undefined;
      }
    }
    return decryptedData;
    }
    catch(error){
      
      return undefined;
    }
  }

export const GetToken = (key) => {
  if (key) {
    let cookie = ("; " + document.cookie)
      .split(`; ${key}=`)
      .pop()
      .split(";")[0];
    return cookie;
  }
  else {
    return undefined;
  }
}

export const SetToken = (tokenkey, token) => {
  if (tokenkey && token) {
    document.cookie = `${tokenkey}= ${token}`;
  }
  return true;
}

export const deleteToken = (tokenkey) => {
  if (tokenkey) {
    document.cookie = `${tokenkey}= ; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
  return undefined;
}

export const axiosFunc    =   async   (data)  =>  {
        
  try{
    let Resp    =   {};
      // if(false){
        if(data?.params){
          data.params = { data: EncryptData(data.params)  }
        }
        else if(data?.data){
          if(!(data?.data instanceof FormData)){
            data.data = { data: EncryptData(data.data)  }
          }
        }
      
    // }
    let token = (GetToken(Config.adminCookieName) ? GetToken(Config.adminCookieName) : (sessionStorage.admin_token?.split(" ")?.[1] ? sessionStorage.admin_token?.split(" ")?.[1] : sessionStorage.admin_token?.split(" ")?.[0]));
    if (data?.headers) {
      data.headers.Authorization = "Bearer " + token
    }
    else {
      data.headers = {
        Authorization: "Bearer " + token
      }
    }
      Resp    =   await axios(data)
      
      if(Resp?.data){
          Resp.data = isEmpty(DecryptData(Resp.data)) ? Resp.data : DecryptData(Resp.data)
      }
      

      return Resp
  }
  catch (err) {
      
    console.error('axiosFunc_error',err?.response)
    if(err?.response?.data){
      err.response.data = isEmpty(DecryptData(err?.response?.data)) ? err?.response?.data : DecryptData(err?.response?.data)
    }
    return {
        data: {
            status: false,
            success: 'error',
            loading: false,
            message: err?.response.data?.message ? err.response.data?.message : "Error Occured",
            error: err?.response?.data?.errors,
        }   
    }
  }
}

export const ImgEmpty = (data) => {
  try {
    return (
      (typeof (data) == 'object' && !data?.name) ||
      data === undefined ||
      data == "undefined" ||
      data === null ||
      (typeof data === 'string' && data.trim().length === 0) ||
      (typeof data === 'string' && data === '0') ||
      (typeof data === 'number' && data === 0)
    )
  }
  catch(err){
    console.error('ImgEmpty_error',err)
    return false
  }
}
